import { useEffect, useState } from 'react';

export type PreviewScope = 'spread' | 'document';

export interface PreviewDialogProps {
  open: boolean;
  spreadIndex: number;
  spreadCount: number;
  busy: boolean;
  error: string | null;
  onExport(scope: PreviewScope): void;
  onClose(): void;
}

export function PreviewDialog({ open, spreadIndex, spreadCount, busy, error, onExport, onClose }: PreviewDialogProps) {
  const [scope, setScope] = useState<PreviewScope>('spread');
  useEffect(() => { if (open) setScope('spread'); }, [open]);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  if (!open) return null;

  return (
    <div className="dialog-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="dialog" role="dialog" aria-modal="true" aria-label="PDF preview">
        <h2>PDF preview</h2>
        <div className="field">
          <label className="opt">
            <input type="radio" name="preview-scope" value="spread" checked={scope === 'spread'} onChange={() => setScope('spread')} />
            This spread ({spreadIndex + 1} of {spreadCount})
          </label>
          <label className="opt">
            <input type="radio" name="preview-scope" value="document" checked={scope === 'document'} onChange={() => setScope('document')} />
            Whole document ({spreadCount} spreads)
          </label>
        </div>
        <p className="small muted">This PDF is a preview only. It is generated from the portal, not from InDesign, and the final artwork may differ.</p>
        {error && <p className="badge danger">{error}</p>}
        <div className="btn-row" style={{ marginTop: 14, justifyContent: 'flex-end' }}>
          <button className="btn ghost" onClick={onClose} disabled={busy}>Cancel</button>
          <button className="btn primary" onClick={() => onExport(scope)} disabled={busy}>{busy ? 'Exporting…' : 'Export PDF'}</button>
        </div>
      </div>
    </div>
  );
}
